import { z } from 'zod';
export const adminClientInfoSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  name: z.string().nullable(),
});
export const adminPaginationInfoSchema = z.object({
  first: z.number(),
  max: z.number(),
  returned: z.number(),
});
export const adminSessionSchema = z.object({
  sessionId: z.string(),
  userId: z.string(),
  username: z.string(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  ipAddress: z.string().nullable(),
  startedDate: z.string(),
  lastAccessedDate: z.string(),
  expiresAt: z.string(),
  rememberMe: z.boolean(),
  offline: z.boolean(),
  clients: z.array(z.string()),
  targetClientId: z.string(),
});

export type QueryStats = z.infer<typeof queryStatsSchema>;
export const queryStatsSchema = z.object({
  callsToday: z.number(),
  callsLastHour: z.number(),
  lastCalledAt: z.string().nullable(),
  avgResponseTimeMs: z.number().nullable().optional(),
  responseTimes: z.array(z.number()).optional(),
});

export type AdminUserSummary = z.infer<typeof adminUserSummarySchema>;
export const adminUserSummarySchema = z.object({
  userId: z.string(),
  username: z.string(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  sessionCount: z.number(),
  lastAccessedDate: z.string(),
  latestSessionId: z.string(),
  ipAddresses: z.array(z.string()),
  queryStats: queryStatsSchema.nullable(),
});

export type AdminClientSessionsResponse = z.infer<typeof adminClientSessionsResponseSchema>;
export const adminClientSessionsResponseSchema = z.object({
  client: adminClientInfoSchema,
  pagination: adminPaginationInfoSchema,
  sessions: z.array(adminSessionSchema),
  users: z.array(adminUserSummarySchema).optional(),
});
